export default __webpack_public_path__ + "static/media/logo-black.deace34a.png";